import React from 'react'
import useSimpleMarkdown from '../../../../hooks/useSimpleMarkdown'
import { useMatchScreen } from '../../../context/MatchScreenContext'
import { trackEvent } from '../../../utils/tracking/mixpanel'
import { trackOptimizelyEvent } from '../../../utils/tracking/optimizely'
import { ExpandableSection } from '../../components/ExpandableSection/ExpandableSection'

import '../../styles/MatchTabsModule/FAQRow.scss'

interface FAQRowProps {
  question: string
  answer: string
}

export const FAQRow = ({ question, answer }: FAQRowProps) => {
  const { state: { pageKey } } = useMatchScreen()
  const { sanitizedMarkup } = useSimpleMarkdown(answer) as { sanitizedMarkup: string }

  const handleToggle = (expanded: boolean) => {
    const properties = {
      page_key: pageKey,
      position: expanded ? 'open' : 'close',
      question
    }
    trackEvent('MatchScreen', 'handoff-faq-accordion-click', properties)
    trackOptimizelyEvent('handoff-faq-accordion-click', properties)
  }

  return (
    <ExpandableSection
      label={question}
      className="faq-row"
      toggleClassName="faq-row__trigger"
      listClassName="faq-row__answer-inner"
      onToggle={handleToggle}
    >
      <div dangerouslySetInnerHTML={{ __html: sanitizedMarkup }} />
    </ExpandableSection>
  )
}
